<template>
  <div class="main-task">
    <main>
      <header>
        <h3>流程管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button @click="messageVisible = true"  style="margin-right: 15px"  :disabled="this.selectedTaskRowKeys.length>0 ? false:true"  v-if="$IA('system:process:changeVersionBatch')">
            <img src="../assets/images/task_upgradation.png" alt=""  style="padding-bottom:3px;">
          </a-button>
          <a-button v-if="$IA('system:process:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search v-model.trim="pagination.searchText" placeholder="名称/描述/包名称"
                            style="width: 200px; " allow-clear :loading="btnLoad"   @input="searchTextChange" @search="searchChange" />
          </a-form-model-item>
          <a-form-model-item  prop="orgId">
            <a-tree-select
                allowClear
                v-model='pagination.orgId'
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="选择部门"
                style="width: 200px;"
                @change="searchChange"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>

          <a-form-model-item >
            <a-button  @click="resetSearch" style="width: 74px">重 置</a-button>
          </a-form-model-item>
        </a-form-model>


      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
        @change="handleTableChange"
        rowKey="id"
        :rowSelection='rowTaskSelection'
        :scroll="{ y: 560 }"
              >
        <template slot="name" slot-scope="text, record">
          <img :src="
            record.canUpdate == 0
              ? require('../assets/images/newest.png')
              : require('../assets/images/update.png')
          " alt="" class="img-lc" />
          <span :title="text"> {{ text }}</span>
        </template>
        <template slot="versionNumber" slot-scope="text">
          <img src="../assets/images/versions.png" class="img-lc" alt="" />
          <span :title="text">{{ text }}</span>
        </template>
        <template slot="priority" slot-scope="text">
          <img class="img-lc" :src="priorityIcon[text]" alt="" />
          <span>{{ priorityName[text] }}</span>
        </template>
        <span slot="action" slot-scope="record" class="table-action-box">
             <a-tooltip  content="" placement="top" effect="light" >
               <template slot="title">
                 <span>开始作业</span>
               </template>
             <i class="table-action ant-caret-icon" @click="taskUpOpen(record)" />
            </a-tooltip>

          <a-dropdown placement="bottomRight" :trigger="['click']">
            <i class="ant-dropdown-link table-action ant-dropdown-icon" />
            <a-menu slot="overlay">
              <a-menu-item v-if="$IA('system:process:update')" @click="handleOpen('修改', record)">
                 <i class="table-edit action_icon" ></i><span>修改</span>
              </a-menu-item>
              <a-menu-item v-if="$IA('system:process:findVersions')" @click="seeOpen('查看', record)">
               <i class="table-view action_icon" ></i><span>查看</span>
              </a-menu-item>
              <a-menu-item v-if="$IA('system:process:delete')" @click="handleOpen('删除', record)">
               <i class="table-delected action_icon" ></i><span>删除</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle + '流程'"  width="600px" :visible="modalVisible" :confirm-loading="submitLoad"
      @ok="handleOk('addForm')" @cancel="resetForm" :footer="modalTitle == '查看' ? null : undefined"  :maskClosable="false" :width="modalTitle == '删除' ? '420px' : '580px'">
      <a-form-model v-if="['添加', '修改'].includes(modalTitle)" layout="vertical" :model="addForm" ref="addForm"
        :rules="addFormRules">
        <a-form-model-item label="修改ID" prop="id" v-show="false">
          <a-input v-model="addForm.id" />
        </a-form-model-item>
        <a-row :gutter="23">
          <a-col :span="12">
            <a-form-model-item label="名称" prop="name">
              <a-input v-model="addForm.name" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="部门" prop="orgId">
              <a-tree-select
                  v-model='addForm.orgId'
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="treeData"
                  :disabled="modalTitle == '修改'"
                  placeholder="选择部门"
                  @change="orgChange($event,'切换')"
                  tree-default-expand-all
                  :replaceFields="{ title: 'name', key: 'id',value:'id' }"
                  show-search
                  :filterTreeNode="filter_tree_node"
              >
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="包" prop="packageId">
              <a-select  show-search :filter-option="filterOption" :disabled="modalTitle == '修改'" v-model="addForm.packageId" placeholder="请选择"
                  @change="packageChagne">
                  <a-select-option :key="item.id" v-for="item in this.packageNameList" :value="item.id" :label="item.name">{{
                  item.name
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="版本号" prop="versionId">
              <a-select v-model="addForm.versionId" placeholder="请选择" :disabled="!addForm.packageId || modalTitle == '修改'"
                >
                <a-select-option :key="item.id" v-for="item in this.versionList" :value="item.id"
                  :label="item.versionNumber">{{ item.versionNumber }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

       
          <a-col :span="12">
            <a-form-model-item label="作业优先级" prop="priority">
              <a-select v-model="addForm.priority" placeholder="请选择">
                <a-select-option v-for="(v, index) in priorityName" :key="index" :value="Number(index)">
                  <img :src="priorityIcon[index]" style="margin-top: -5px" />
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="环境" prop="environmentId">
              <a-select  show-search :filter-option="filterOption" :disabled="modalTitle == '修改'" v-model="addForm.environmentId" placeholder="请选择">
                <a-select-option :key="item.id" v-for="item in this.environmentList" :value="item.id" :label="item.name">{{
                item.name
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="描述" prop="description">
              <a-textarea v-model="addForm.description" placeholder="请输入"  />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <div v-if="addForm.parameter != ''">
          <h4>附加参数</h4>
          <a-table :columns="parameterColumns" :data-source="addForm.parameter"  :loading="btnLoad" :pagination="false"
            :scroll="{ y: 140 }">
            <template slot="argName" slot-scope="text">
              <span>{{ text }}</span>
            </template>
            <template slot="defaultValue" slot-scope="text, record, index">
              <a-form-model-item :prop="'parameter.' + index + '.defaultValue'">
                <a-input-number v-model="record.defaultValue" placeholder="请输入" :min="1" :max="999"
                  v-if="record.argType === 1" style="width: 100%" />
                <a-input v-model="record.defaultValue" placeholder="请输入"
                  v-if="record.argType === 2 || record.argType === 4" />
                <a-select v-model="record.defaultValue" placeholder="请输入" v-if="record.argType === 3">
                  <a-select-option value="true">是</a-select-option>
                  <a-select-option value="false">否</a-select-option>
                </a-select>
              </a-form-model-item>
            </template>
          </a-table>
        </div> -->
      </a-form-model>
      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该流程,是否继续?</p>
      </div>
    </a-modal>

    <!-- 查看模态框 -->
    <a-modal centered title="版本管理" :visible="seeTaskVisible" width="600px" @cancel="seeTaskVisible = false"  :maskClosable="false">
      <div class="trreSelect">
        <div>
          <p><strong>包：</strong>{{ seeSingleDta.packageName }}</p>
          <p><strong>环境：</strong>{{ seeSingleDta.environmentName }}</p>
          <p><strong>版本：</strong>{{ seeSingleDta.versionNumber }}</p>
        </div>

        <a-tabs default-active-key="1" >
          <a-tab-pane key="1" tab="版本管理">
           <!-- 版本 -->
           <a-table :columns="versionColumns" :data-source="versionData" :pagination="versionCondition" :footer="null"
            @change="versionTableChange">
          <!-- 0 使用 1 没使用 -->
          <span slot="action" slot-scope="record">
            <a-button :loading="btnLoad" :disabled="record.status == 0" @click="switchClick(record)" v-if="$IA('system:process:changeVersion')">
              <a-icon :type="
                record.status == 0 ? 'check-circle' : 'exclamation-circle'
              " :style="record.status == 0 ? 'color:green' : 'color:orange'" />{{ record.status == 0 ? "使用中" : "未使用"
              }}
            </a-button>
          </span>
        </a-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="参数" >
            <a-table :columns="parameterColumns" :data-source="startUpForm.parameter" :loading="btnLoad"
                :pagination="false" :scroll="{ y: 140 }">
              <template slot="argName" slot-scope="text, record, index">
                <span>{{ text }}  <span style="color: red" v-if="record.required == 1">*</span> </span>
              </template>
                <template slot="defaultValue" slot-scope="text, record, index">
                  <a-form-model-item :prop="'parameter.' + index + '.defaultValue'"
                                     :rules="{ required: record.required == 1 , message: '请输入参数值', trigger: 'blur' }">
                    <a-input-number  disabled v-model="record.defaultValue" placeholder="请输入" :min="1" :max="999"
                      v-if="record.argType === 1" style="width: 100%" />
                    <a-input disabled v-model="record.defaultValue" placeholder="请输入"
                      v-if="record.argType === 2 || record.argType === 4" />
                    <a-select disabled v-model="record.defaultValue" placeholder="请输入" v-if="record.argType === 3" style="width: 100%">
                      <a-select-option value="true">是</a-select-option>
                      <a-select-option value="false">否</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </template>
              </a-table>
          </a-tab-pane>
        </a-tabs>

      </div>
      <template slot="footer">
        <a-button @click="handleCancel" type="primary">关闭</a-button>
      </template>
    </a-modal>

    <!-- 启动流程 -->
    <a-modal centered :title="'开始作业' + '：' + this.singleTaskData.name" :visible="startUpTaskVisible" width="700px"
      @cancel="startResetForm" :confirm-loading="submitLoad" @ok="startUpSubmit" class="ant-start-modal"  :maskClosable="false">
      <i class="ant-start-underline"></i>
      <a-form-model :rules="startUpRules" :model="startUpForm" ref="startUpForm">
        <a-row :gutter="23">
          <a-col :span="16">
            <a-form-model-item label="部门" prop="orgId">
              <a-tree-select
                disabled
                v-model='startUpForm.orgId'
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                @change="treeChange"
                placeholder="选择部门"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
              >
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="是否录屏" prop="screenRecord"  >
              <a-switch v-model="startUpForm.screenRecord" checked-children="开" un-checked-children="关" :checked="startUpForm.screenRecord == 1 ? true : false "  />
            </a-form-model-item>
          </a-col>
          <a-col :span="15">
            <a-form-model-item label="流程" prop="processId">
              <a-select v-model="startUpForm.processId"    disabled  show-search   :filter-option="filterOption" placeholder="请选择" @change="taskChange">
                <a-select-option :key="item.id" v-for="item in this.taskList" :value="item.id" :label="item.name">{{
                item.name
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="9">
            <a-form-model-item label="作业优先级" prop="priority">
              <a-select v-model="startUpForm.priority" placeholder="请选择">
                <a-select-option v-for="(v, index) in priorityName" :key="index" :value="Number(index)">
                  <img :src="priorityIcon[index]" style="margin-top: -5px" />
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>


          <a-col :span="24">
            <a-tabs default-active-key="1" >
              <a-tab-pane key="1" tab="执行设备" >
                <a-col :span="24" style="padding-top:1px ;">
                  <a-form-model-item prop="type" style="border-bottom: 1px solid #c7c7c7;margin:-10px 0 10px;">
                    <a-radio-group v-model="startUpForm.type">
                      <a-radio :value="1">特定机器人</a-radio>
                      <a-radio :value="2">动态分配</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="startUpForm.type == 1">
                  <a-form-model :model="robotCondition" ref="searchRobotBar" :layout="formLayout" style="margin: 0px 0 15px;">
                    <a-form-model-item prop="searchText">
                      <a-input-search v-model.trim="robotCondition.searchText" placeholder="机器人/计算机"
                                      style="width: 200px;margin-top: 2px" allow-clear    @input="searchRobotTextChange" @search="robotSearchChange" />
                    </a-form-model-item>
                    <a-form-model-item prop="status">
                      <a-select v-model="robotCondition.status" placeholder="状态" style="width: 180px; "
                                allowClear @change="robotSearchChange">
                        <a-select-option :value="0">可用</a-select-option>
                        <a-select-option :value="1">断开连接</a-select-option>
                        <a-select-option :value="2">忙碌</a-select-option>
                        <a-select-option :value="3">无响应</a-select-option>
                      </a-select>
                    </a-form-model-item>

                    <a-form-model-item style="float: right;margin-right: 0px;">
                      <a-button icon="redo" @click="resetRobotSearch" size="small" >重 置</a-button>
                    </a-form-model-item>
                  </a-form-model>

                  <a-table :columns="robotColumns"  :data-source="robotData" :pagination="robotCondition" @change="robotTableChange" :loading="robotTableLoad"
                    width="400px" :rowSelection="{
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }" :scroll="{ y: 130 }">
                    <template slot="name" slot-scope="text, record">
                      <img :src="statsIcon[record.status]" />
                      <span> {{ text }}</span>
                    </template>
                    <template slot="status" slot-scope="text">
                      <span> {{ statusName[text] }}</span>
                    </template>
                  </a-table>
                </a-col>
                <a-col :span="8" v-if="startUpForm.type == 2">
                  <a-form-model-item label="执行流程次数" prop="executeCount">
                    <a-input-number placeholder="请输入" style="width: 100%" v-model="startUpForm.executeCount" :min="1"
                      :max="999" />
                  </a-form-model-item>
                </a-col>
              </a-tab-pane>
              <a-tab-pane key="2" tab="附加参数" force-render>
                <a-col :span="24" >
                  <a-table :columns="parameterColumns" :data-source="startUpForm.parameter" :loading="btnLoad"
                    :pagination="false" :scroll="{ y: 140 }">
                    <template slot="argName" slot-scope="text, record, index">
                      <span>{{ text }}  <span style="color: red" v-if="record.required == 1">*</span> </span>
                    </template>
                    <template slot="defaultValue" slot-scope="text, record, index">

                      <a-form-model-item :prop="'parameter.' + index + '.defaultValue'"  :rules="{ required: record.required == 1 , message: '请输入参数值', trigger: 'blur' }">
                        <a-input-number v-model="record.defaultValue" placeholder="请输入" :min="1" :max="999"
                          v-if="record.argType === 1" style="width: 100%" />
                        <a-input v-model="record.defaultValue" placeholder="请输入"
                          v-if="record.argType === 2 || record.argType === 4" />
                        <a-select v-model="record.defaultValue" placeholder="请输入" v-if="record.argType === 3">
                          <a-select-option value="true">是</a-select-option>
                          <a-select-option value="false">否</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table>
                </a-col> 
              </a-tab-pane>
          
            </a-tabs>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <!-- 提示框 -->
    <a-modal :visible="messageVisible" width="450px" :closable="false" @cancel="messageVisible = false" class="message-modal" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="messageVisible = false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="submitLoad" @click="upgradationClick">
          确定
        </a-button>
      </template>
      <p style="padding:40px 20px 20px;margin-bottom:0px;font-weight:600;font-size: 16px;">  <a-icon type="exclamation-circle" style="color: #ff7d00;margin-right: 10px;font-size: 20px" theme="filled" />是否确定要将选定流程更新为其包的最新版本?</p>
    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      robotTableLoad: false,
      submitLoad:false,
      pagination: {
        searchText: "",
        orgId:undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      // 分页参数
      pagCurrent:{},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          ellipsis: true,
          scopedSlots: { customRender: "name" },
        },
        {
          title: "版本号",
          dataIndex: "versionNumber",
          key: "versionNumber",
          ellipsis: true,
          scopedSlots: { customRender: "versionNumber" },
        },
        {
          title: "环境",
          ellipsis: true,
          dataIndex: "environmentName",
          key: "environmentName",
        },
        {
          title: "包名称",
          ellipsis: true,
          dataIndex: "packageName",
          key: "packageName",
        },
        {
          title: "部门",
          ellipsis: true,
          dataIndex: "orgName",
          key: "orgName",
        },
        {
          title: "作业优先级",
          dataIndex: "priority",
          key: "priority",
          ellipsis: true,
          scopedSlots: { customRender: "priority" },
        },
        {
          title: "描述",
          dataIndex: "description",
          key: "description",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 85,
          scopedSlots: { customRender: "action" },
        },
      ],
      formLayout: "inline",
      queryCondition: {},
      versionCondition: {},
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 单行数据
      singleData: {},
      // 查看单行数据
      seeSingleDta: {},
      // 部门列表
      treeData:[],
      // 添加表单
      addForm: {
        id: '',
        name: '',
        packageId: undefined,
        orgId:undefined,
        versionId: undefined,
        environmentId: undefined,
        versionNumber: "",
        description: "",
        priority: 1,
        parameter:'',
      },
      // 作业优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
      },
      priorityIcon: {
        0: require("../assets/images/low.png"),
        1: require("../assets/images/normal.png"),
        2: require("../assets/images/height.png"),
        3: require("../assets/images/inherited.png"),
      },
      statsIcon: {
        0: require("../assets/images/newest.png"),
        1: require("../assets/images/break.png"),
        2: require("../assets/images/beBusy.png"),
      },
      // 包名称下拉框
      packageNameList: {},
      // 版本下拉框
      versionList: {},
      // 环境下拉框
      environmentList: {},
      addFormRules: {
        name: [
           { max: 20, message: '流程名称最长不能超过20个字符' },
          {
            pattern: /^[^\\/:*?\"<>]{1,20}$/,
            message: '名称中包含特使字符\\  /:  * ? ” <  >，请检查',
          },],
        packageId: [{ required: true, message: "包名称不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        versionId: [{ required: true, message: "版本号不能为空" }],
        environmentId: [{ required: true, message: "环境不能为空" }],
        description: [{ max: 250, message: '描述最长不能超过250个字符' }],
        priority: [{ required: true, message: "作业优先级不能为空" }],
      },
      // 附加参数
      parameter: '',
      seeTaskVisible: false,
      parameterColumns: [
        {
          title: "参数名称",
          dataIndex: "argName",
          key: "argName",
          scopedSlots: { customRender: "argName" },
        },
        {
          title: "参数值",
          dataIndex: "defaultValue",
          key: "defaultValue",
          scopedSlots: { customRender: "defaultValue" },
        },
      ],
      // 查看
      versionColumns: [
        {
          title: " 版本",
          dataIndex: "versionNumber",
          key: "versionNumber",
        },
        {
          title: "发布日期",
          dataIndex: "publishTime",
          key: "publishTime",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 60,
          scopedSlots: { customRender: "action" },
        },
      ],
      versionPagination: {
        id: "",
        pageSize: 5,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '30', '40'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      robotCondition:{
        searchText: "",
        status:undefined,
        current: 1,
        pageSize: 5,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showTotal: (total, range) => `共 ${total} 条记录  `,
        processId: "",
      },
      versionData: [],
      versionTabKey:'1',
      versionSwitchForm: {
        processId: "",
        versionId: "",
        processName:""
      },
      // 启动流程
      startUpTaskVisible: false,
      // 提示框
      messageVisible: false,
      // 单行数据
      singleTaskData: {},
      startUpForm: {
        orgId:undefined,
        processId: undefined,
        priority: 3,
        type: 1,
        robotIds: [],
        executeCount: 1,
        parameter: '',
        screenRecord:false
      },
      startUpRules: {
        processId: [{ required: true, message: "流程不能为空" }],
        priority: [{ required: true, message: "作业优先级不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        type: [{ required: true, message: "执行设备不能为空" }],
        executeCount: [{ required: true, message: "执行流程次数不能为空" }],
      },
      // 流程下拉数据
      taskList: [],
      selectedTaskRowKeys:[],
      taskSelectForm:{
        packageId:[],
      },
      robotData: [],
      selectedRowKeys: [], //复选框数据
      statusName: {
        0: "可用",
        1: "断开连接",
        2: "忙碌",
        3: "无响应",
      },
      // 流程选中
      processSelection:{},

      robotColumns: [
        {
          title: "机器人",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "计算机",
          dataIndex: "machineName",
          key: "machineName",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },

       
      ],
    };
  },
  computed: {
    rowTaskSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
         let obj = [];
          selectedRows.forEach((element) => {
            obj.push(element.packageId);
          });
          this.taskSelectForm.packageId = obj 
          this.selectedTaskRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.canUpdate === 0, // Column configuration not to be checked
          },
        }),
        selectedRowKeys: this.selectedTaskRowKeys,
      };
    },
  },
  methods: {

    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 开启搜索
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 流程一键升级
    upgradationClick(){
      this.messageVisible = true
      this.submitLoad = true
      this.axios
        .post('/process/changeVersionBatch', this.taskSelectForm.packageId)
        .then((res) => {
          this.submitLoad = false;
          if (res.code === 200) {
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
            this.handleTableChange(this.pagCurrent);
            this.messageVisible = false
          }
        })
        .catch((err) => {
          this.submitLoad = false;
          console.log(err);
        });
    },
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.resetFields();
      }
      this.modalVisible = false;
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    startResetForm() {
      this.$refs.startUpForm.resetFields();
      this.startUpTaskVisible = false;
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.singleData = data;
      // this.packageSelect();
      switch (title) {
        case "添加":
          this.addForm.parameter = '';
          // this.orgChange( this.addForm.orgId)
          break;
        case '修改':
          this.$nextTick(() => {
            this.addForm = this.$lodash.pick(
              this.singleData,
              this.$lodash.keys(this.addForm)
            );
          this.orgChange( this.addForm.orgId)
          this.packageChagne(this.singleData.packageId)
          this.versionChange(this.singleData.versionId)
          })
          break;
        case "删除":
          break;
      }
    },
    // 打开查看模态框
    seeOpen(title, data) {
      this.seeSingleDta = data;
      this.seeTaskVisible = true;
      this.versionPagination.id = data.id;
      this.versionSwitchForm.processId = data.id;
      this.versionSwitchForm.processName = data.name
      this.versionSearchChange()
      this.parameterList(data.versionId,data.id,'startUpForm')
      // this.versionTabKey = '1'
    },
    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == '删除') {
        this.submitLoad = true;
        this.axios
          .delete("/process/delete", {
            params: {
              id: this.singleData.id,
            },
          })
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              this.modalVisible = false
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.tableAjax()
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
        return
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let saveData = "";
          saveData = this.$lodash.cloneDeep(this.addForm);
          saveData.parameter = saveData.parameter
            ? JSON.stringify(saveData.parameter)
            : "";
          this.axios
            .post("/process/" + (this.modalTitle == '修改' ? 'update' : 'save'), saveData)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.resetForm()
                this.tableAjax()
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
         }
      });
    },
     // 监听部门
    treeChange(val){
      this.startUpForm.processId = undefined
      this.startUpForm.parameter = ''
      this.robotData = []
      this.axios
        .post("/process/findProcess",{orgId:val})
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.taskList = res.data;
          }
        })
        .catch((err) => { 
          console.log(err);
        });
    },
    // 包名称下拉框
    packageSelect(val) {
      this.axios
        .post("/package/selectPackages","orgId=" + val)
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.packageNameList = res.data;
          }
        })
        .catch((err) => {1
          console.log(err);
        });
    },
    // 包名称监听-版本联动
    packageChagne(val) {
      if (this.modalTitle == '添加') {
        this.addForm.versionId = undefined;
      }
      this.addForm.parameter = ''
      this.axios
        .post("/package/selectVersions", "packageId=" + val)
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.versionList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 环境下拉框
    environmentSelect(id,title) {
      if(title == '切换'){
        this.addForm.environmentId = undefined
      }
      this.axios
        .post("/environment/selectEnvironments",{orgId:id})
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.environmentList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 版本号监听-联动附加参数
    versionChange(val) {
      switch (this.modalTitle) {
        case '添加':
          this.axios
            .post("/process/findProcessArgs", "versionId=" + val)
            .then((res) => {
              if (res.code === 200) {
                this.addForm.parameter = res.data;
                for (let i = 0; i < this.addForm.parameter.length; i++) {
                  if (this.addForm.parameter[i].defaultValue) {
                    this.addForm.parameter[i].defaultValue = undefined;
                  }else{
                    this.addForm.parameter[i].defaultValue = undefined;
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case '修改':
          this.parameterList(this.singleData.versionId, this.singleData.id, 'addForm')
          break;
      }

    },
    // 版本查看关闭
    handleCancel() {
      this.versionPagination.current = 1;
      this.seeTaskVisible = false;
      this.versionTableChange(this.versionPagination);
    },
    // 版本切换
    switchClick(data) {
      this.btnLoad = true;
      this.versionSwitchForm.versionId = data.id;
      this.axios
        .post(
          "/process/changeVersion",
          this.$qs.stringify(this.versionSwitchForm)
        )
        .then((res) => {
          this.btnLoad = false;
          if (res.code === 200) {
            this.versionTableChange(this.versionPagination);
            this.handleTableChange(this.pagCurrent);
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
          }
        })
        .catch((err) => {
          this.btnLoad = false;
          console.log(err);
        });
    },
    // 启动流程-打开模态框
    taskUpOpen(data) {
      this.startUpTaskVisible = true;
      this.singleTaskData = data;
      this.startUpForm.id = data.id;
      this.startUpForm.orgId = data.orgId
      this.startUpForm.processId = data.id;
      this.startUpForm.priority = data.priority;
      this.startUpForm.executeCount = "";
      this.selectedRowKeys = [];
      this.startUpForm.robotIds = ''
      this.singleData = data

      this.robotCondition.status = undefined
      this.robotCondition.searchText = ''
      this.robotCondition.current = 1
      this.robotCondition.pageSize = 5
      this.robotCondition.total = 0


      this.taskChange(this.startUpForm.processId);
      this.allorgList()
      
    },
    // 监听表单部门
    orgChange(val,title){
      this.environmentSelect(val,title)
      this.packageSelect(val)
    },
    // 监听流程下拉框-选择机器人
    taskChange(val) {
      this.axios
      .post("/process/findProcess",{orgId:this.startUpForm.orgId})
        .then((res) => {
          if (res.code === 200) {
            this.taskList = res.data;
            this.taskList.forEach((v) => {
              if (val === v.id) {
                // 附加参数
                this.parameterList(v.versionId, v.id, 'startUpForm')
                this.robotCondition.processId = v.id
                this.robotTableChange('','','',v)

              }
            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 特定机器人列表
    allRobotList() {
      this.robotTableLoad = true
      this.axios
        .post(
          "/robot/findRobotsByProcessId",
            this.robotCondition
        )
        .then((res) => {
          this.robotTableLoad = false
          // console.log(res.data);
          if (res.code === 200) {
            this.robotData = res.data.records;
            this.robotCondition.total = res.data.total;

            this.selectedRowKeys = this.singleData.robotIds
                ? this.singleData.robotIds.split(",")
                : [];
          }
        })
        .catch((err) => {
          this.robotTableLoad = false
          console.log(err);
        });
    },
    // 附加参数列表
    parameterList(versionId, id, title) {
      this.axios
        .post(
          "/process/findProcessArgsByProcess",
          "versionId=" + versionId + "&processId=" + id
        )
        .then((res) => {
          if (res.code === 200) {
            this[title].parameter = res.data;
            for (let i = 0; i < this[title].parameter.length; i++) {
              if (this[title].parameter[i].defaultValue) {
                this[title].parameter[i].defaultValue = undefined;
              }else{
                this[title].parameter[i].defaultValue = undefined;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 启动提交
    startUpSubmit() {
      this.$refs.startUpForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let saveData = "";
          saveData = this.$lodash.cloneDeep(this.startUpForm);
          saveData.parameter = saveData.parameter
            ? JSON.stringify(saveData.parameter)
            : "";
          saveData.robotIds = saveData.robotIds ? saveData.robotIds.join(",") : "";
          if (!saveData.screenRecord ){
            saveData.screenRecord = 0
          }else{
            saveData.screenRecord = 1
          }
          this.axios
            .post("/job/save", saveData)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                this.startUpTaskVisible = false;
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagination);
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
        }else{
          this.$message.warning('请检查必填项(含附加参数)是否全部填写完成');
        }
      });
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 重置搜索
    resetRobotSearch() {
      this.$refs.searchRobotBar.resetFields()
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.robotSearchChange()
    },
    searchRobotTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.robotSearchChange(val)
      }, 1200);
    },
    // 搜索
    robotSearchChange(v) {
      this.robotCondition = this.$lodash.cloneDeep(this.robotCondition)
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.allRobotList()
    },
    // 监听分配机器表格翻页
    robotTableChange(pagination, filters, sorter,data) {
      this.robotCondition.pageNo = pagination.current ? pagination.current : 1
      this.robotCondition.current = pagination.current ? pagination.current : 1
      this.robotCondition.pageSize = pagination.pageSize ? pagination.pageSize : 5
     
      this.selectedRowKeys = []
      this.startUpForm.robotIds = undefined
      this.allRobotList()
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {

      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.selectedTaskRowKeys = []
      this.tableLoad = true;
      this.axios
        .post("/process/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
    // 监听表格复选
    onSelectChange(selectedRowKeys, selectedRows) {
      let obj = [];
      selectedRows.forEach((element) => {
        obj.push(element.id);
      });
      this.startUpForm.robotIds = obj;
      this.selectedRowKeys = selectedRowKeys;
    },
    // 搜索
    versionSearchChange(v) {
      this.versionCondition = this.$lodash.cloneDeep(this.versionPagination)
      this.versionTableAjax()
    },
    // 监听版本翻页
    versionTableChange(pagination, filters, sorter) {
      this.versionCondition.pageNo = pagination.current ? pagination.current : 1
      this.versionCondition.current = pagination.current ? pagination.current : 1
      this.versionCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.versionTableAjax()
    },
    // 版本翻页请求
    versionTableAjax() {
      this.tableLoad = true;
      this.axios
        .post(
          "/process/findVersions",
          this.$qs.stringify(this.versionCondition)
        )
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.versionData = res.data.records;
            this.versionCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.searchChange();
    this.allorgList()
  },
};
</script>

<style lang="scss" scoped>
.main-task {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    .img-lc {
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -6px;
    }
    i.ant-caret-icon {
      background: url("../assets/images/icon_btn/Run.png") no-repeat center;
    }

    i.ant-dropdown-icon {
      background: url("../assets/images/Table_action.png") no-repeat center;
    }

    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      border-radius: 20px;
      vertical-align: top;

      &:active {
        background-color: #d8e6ff;
      }
    }

  }
}

//启动模态框样式
.ant-start-modal {
  ::v-deep .ant-modal {
    .ant-modal-header {
      // border-bottom: 2px solid #c7c7c7;
      position: relative;
    }

    .ant-modal-body {
      .ant-start-underline {
        // display: inline-block;
        // width: 70px;
        // border-bottom: 2px solid #2869f9;
        // position: absolute;
        // margin-top: -2px;
      }

      .ant-form-item {

      // 下拉框激活状态颜色
      .ant-select-open .ant-select-selection {
        border-color: #fff;
        border-bottom-color: #40a9ff;
      }

      // 边框线颜色
      .ant-select-selection {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #c7c7c7;
      }

      // 下拉框阴影
      .ant-select-selection--single {
        box-shadow: none;
      }

      // 下拉框hover效果
      .ant-select-selection:hover {
        border-color: #fff;
        border-bottom-color: #40a9ff;
        border-right-width: 1px !important;
      }

      // 字体左边间距
      .ant-select-selection__rendered {
        margin-left: 0px;
      }

      // 计数器样式
      .has-error .ant-select-selection {
        border-bottom-color: #f5222d;
      }

      // 激活样式
      .ant-input-number:focus{
        box-shadow: none;
        border-bottom-color: #40a9ff;
      }

      .has-error .ant-input-number-focused{
        box-shadow: none;
        border-bottom-color: #f5222d;
      }
      .ant-input-number-focused {
        box-shadow: none;
        border-bottom-color: #40a9ff;
      }
      .ant-input-number-input{
        padding: 0;
      }
       .ant-input:focus,:hover {
        box-shadow: none;
        border-bottom-color: #40a9ff;
      }
       .has-error .ant-input, .has-error .ant-input:hover{
        border-color: #f5222d;
      }
       .ant-input {
          border: none;
          padding: 0px;
          border-radius: 0px;
          border-bottom: 1px solid #c7c7c7;
          border-bottom-color: #c7c7c7 !important;
      }
      .ant-input-number{
          border: none;
          border-bottom: 1px solid #c7c7c7;
          border-bottom-color: #c7c7c7 !important;
          padding: 0px;
      }
        .ant-input:focus{
          box-shadow: 0 0 0px rgba(24, 144, 255, 0.2);
          border-bottom-color: #40a9ff !important;
        }
        .ant-input:hover {
          border-bottom-color: #40a9ff !important;
        }
      // 禁用
      .ant-select-disabled .ant-select-selection{
          background:transparent;
          border-bottom: 1px dashed #c7c7c7;
        }
     }


      // 表格宽度调整
      .ant-table-placeholder {
        width: 660px;
        margin: 0 auto;
      }
    }

    .ant-table-thead>tr>th {
      background: #fafafa;
    }
  }
}

.ant-form-vertical .ant-form-item {
  padding-bottom: 0px;
}

.ant-table-content {
  .ant-form-item {
    margin-bottom: 0px;
  }
}

th.tableClass {
  background-color: red;
}

//::v-deep .ant-table-header{
//  margin-right: -10px;
//}


// 切换框
::v-deep .ant-tabs-nav{
  width: 100%;
  .ant-tabs-tab{
     width: 50%;
     text-align: center;
  }
  .ant-tabs-tab:nth-child(1){
    margin: 0px;
  }
  .ant-tabs-tab-active{
    background-color: #fafafa;
    font-weight: 600;
  }
}

.message-modal{
  ::v-deep .ant-modal{
    margin-top: 0px;
  }
}
</style>